import React from "react";
import { useTrail, animated } from "react-spring";

export const MultipleAnimation = ({
	items,
	itemProp,
	loading = false,
	children,
	mass = 10,
	tension = 1500,
	friction = 170,
}) => {
	const config = { mass: mass, tension: tension, friction: friction };

	const trail = useTrail(items.length, {
		config,
		opacity: !loading ? 1 : 0,
		x: !loading ? 0 : 1,
		from: { opacity: 0, x: 40 },
	});

	const renderChildren = (index) =>
		React.Children.map(children, (child) =>
			React.cloneElement(
				child,
				itemProp
					? { [itemProp]: items[index], key: index, first: index == 0 }
					: { ...items[index], key: index, first: index == 0 }
			)
		);

	return trail.map(({ x, ...rest }, index) => (
		<animated.div
			key={`multiple-animation-item-${index}`}
			style={{
				...rest,
				transform: x.interpolate((x) => `translate3d(0,${x}px,0)`),
			}}
		>
			{renderChildren(index)}
		</animated.div>
	));
};
